'use client';

import {Button, ButtonProps} from 'common/components/button';
import {useRouter} from 'next/navigation';
import {FC} from 'react';

interface LinkButtonProps extends Omit<ButtonProps, 'onClick'> {
  href: string;
  replace?: boolean;
}

export const LinkButton: FC<LinkButtonProps> = ({href, replace, ...buttonProps}) => {
  const router = useRouter();

  return (
    <Button
      {...buttonProps}
      onClick={() => {
        if (replace) {
          router.replace(href);
        } else {
          router.push(href);
        }
      }}
    />
  );
};
